

export default class State
{
    /**
     * 获取或设置设备环境.
     * @member
     * @returns string
     */
    public device: string = "desktop";

    /**
     * 获取或设置色弱模式
     * @member
     * @returns boolean
     */
    public weak: boolean = false;

    /**
     * 获取或设置菜单
     * @member
     * @returns boolean
     */
    public sidebar: boolean = true;

    /**
     * 获取或设置tab模式
     * @member
     * @returns boolean
     */
    public multiTab: boolean = false;

    /**
     * 切换主题
     * @member
     * @returns string
     */
    public theme: string = "";

    /**
     * 布局模式
     * @member
     * @returns string
     */
    public layout: string = "";

    /**
     * 内容宽度
     * @member
     * @returns string
     */
    public contentWidth: string = "";
    
    /**
     * 颜色
     * @member
     * @returns string
     */
    public color: string = "";

    /**
     * 是否显示头部
     * @member
     * @returns boolean
     */
    public autoHideHeader: boolean = false;

    /**
     * 是否固定头部
     * @member
     * @returns boolean
     */
    public fixedHeader: boolean = false;

    /**
     * 是否固定左侧菜单
     * @member
     * @returns boolean
     */
    public fixSiderbar: boolean = false;

    
}
